import React from 'react'
import { gql, useQuery } from '@apollo/client'
import GridDefinitions from './GridDefinitionsContext'

const SCHEMA = gql`
query schema {
  __schema {
    types {
      name
      kind
      fields {
        name
        type {
          kind
          name
          enumValues {
            name
            description
          }
          ofType {
            enumValues {
              name
              description
            }
            kind
            name
            ofType {
              kind
              name
            }
          }
        }
      }
    }
  }
}
`
const getDataTypeAndEnumOptionsFromProperty = (type, depth) => {
  if (type === null || type === undefined || type.kind === undefined) {
    return null;
  }
  
  if (type.kind === "SCALAR") {
    return { name: type.name, enumValues: null, fields: null }
  }
  if (type.kind === "ENUM") {    
    if (type.enumValues == null) return null;
    return { name: "ENUM", enumValues: type.enumValues.map(x => x.name), fields: null }
  }
  if (type.kind === "OBJECT") {
    if (depth === 4) {
      console.log("TOO DEEP");
      return null;
    }
    return { name: "OBJECT", enumValues: null, fields: handleObjectPropertyFields(type, depth + 1) }
  }

  if (type.kind === "LIST") {
    const result = getDataTypeAndEnumOptionsFromProperty(type.ofType, depth + 1);
    if (result !== null) {
      result.name = result.name + "[]";
    }

    return result;
  }
  if (type.kind === "NON_NULL") {

    return getDataTypeAndEnumOptionsFromProperty(type.ofType, depth + 1)
  }
}
const handleObjectPropertyFields = (type, depth) => {
  
  const fields = [];
  if (!type || !type.fields) return;
  for (let k = 0; k < type.fields.length; k++) {
    const dataType = getDataTypeAndEnumOptionsFromProperty(type.fields[k].type, depth);    
    if (dataType === null || dataType.name === "UUID") continue;
    if (dataType.fields !== undefined) {
      fields.push({ propertyName: type.fields[k].name, dataType: dataType.name, enumValues: dataType.enumValues, fields: dataType.fields });
    }
  }
  return fields;
}

const GridProvider = ({ children }) => {

  const { data } = useQuery(SCHEMA)

  if (!data) return <></>
  const collectionSegments = data?.__schema.types.filter(x => x.name.endsWith('sCollectionSegment'))

  const gridDefinitions = [];
  for (let i = 0; i < collectionSegments.length; i++) {
    const collectionSegment = collectionSegments[i];        
    const gridDefinitionName = collectionSegment.name.replace('CollectionSegment', '');
    let entityType = "";
    const field=collectionSegment.fields.filter(x => x.name === "items")[0];
    if (field.type.ofType.kind == "NON_NULL") {
      entityType = data?.__schema.types.filter(x => x.name === field.type.ofType.ofType.name)[0];
    } else {
      entityType = data?.__schema.types.filter(x => x.name === field.type.ofType.name)[0];
    }
    const properties = handleObjectPropertyFields(entityType);

    gridDefinitions.push({
      typeName: gridDefinitionName.charAt(0).toLowerCase() + gridDefinitionName.slice(1),
      columnDefinitions: properties,
    });
  }
  return (
    <GridDefinitions.Provider value={gridDefinitions}>
      {children}
    </GridDefinitions.Provider>
  )
}
export default GridProvider
